module.exports = __webpack_public_path__ + "static/media/headerNewPic.0a366ea0.svg";